import { Check } from 'lucide-react';
import type { DeliveryMode } from './share-care-plan-modal.types';

type ShareCarePlanSuccessProps = {
  recipientLabel: string;
  mode: DeliveryMode;
};

/**
 * Success state for the Share Care Plan modal. The check badge "pops" in with
 * a spring-like scale, a one-shot ring pulses out behind it, and the copy
 * fades up just after — a short celebratory beat before the modal
 * auto-dismisses. All motion is gated behind `motion-safe` so users with
 * `prefers-reduced-motion` get the calm, static version.
 */
export const ShareCarePlanSuccess = ({
  recipientLabel,
  mode,
}: ShareCarePlanSuccessProps) => (
  <div
    className="flex flex-col items-center gap-3 py-8 text-center"
    role="status"
    aria-live="polite"
  >
    <span className="relative flex h-12 w-12 items-center justify-center">
      <span
        className="absolute inset-0 rounded-full bg-sage/30 motion-safe:animate-success-ring motion-reduce:hidden"
        aria-hidden
      />
      <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-sage-bg text-sage motion-safe:animate-success-pop">
        <Check className="h-6 w-6" aria-hidden />
      </span>
    </span>
    <div className="motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-1 motion-safe:duration-300 motion-safe:delay-150 motion-safe:fill-mode-both">
      <p className="text-base font-medium text-gray-900">
        Care guide sent to {recipientLabel}
      </p>
      <p className="mt-1 text-sm text-gray-600">
        {mode === 'email'
          ? 'We will email a link plus the PDF. You can close this window.'
          : 'We will drop the plan into your conversation in the bQuest app.'}
      </p>
    </div>
  </div>
);
